import React from 'react';
import {
    BoundarySign,
    getSupportedOppositeBoundarySigns,
} from 'utils/filter/filter';
import ComparisonControl from 'utils/components/FiltersModal/comparison/ComparisonControl';
import {
    BoundaryComparison,
    SupportedComparisonValue,
} from 'utils/components/FiltersModal/comparison/FilterComparison';

interface SecondComparisonControlProps {
    columnName?: string;
    firstSign: BoundarySign;
    secondComparison: BoundaryComparison;
    onSignChange: (sign: BoundarySign) => void;
    onValueChange: (value: SupportedComparisonValue) => void;
    rangeError?: boolean;
    onInputEnter: () => void;
}

export default function SecondComparisonControl(
    props: SecondComparisonControlProps
) {
    const {
        columnName,
        firstSign,
        secondComparison,
        onSignChange,
        onValueChange,
        rangeError,
        onInputEnter,
    } = props;

    const rangeErrorMessage = rangeError
        ? 'Please enter a valid range'
        : undefined;

    return (
        <ComparisonControl
            columnName={columnName}
            availableSigns={getSupportedOppositeBoundarySigns(firstSign)}
            isExactOrFirstInRange={true}
            valueType={secondComparison.valueType}
            sign={secondComparison.sign}
            value={secondComparison.value}
            onSignChange={(sign) => onSignChange(sign as BoundarySign)}
            onValueChange={onValueChange}
            error={rangeError}
            errorMessage={rangeErrorMessage}
            onInputEnter={onInputEnter}
        />
    );
}
